import { useState } from "react";
import useComponentsStore from "../../store/componentsStateStore";
import useHintStore from "../../store/hintStateStore";
import {
  getGeneralImage,
  generateStyleClasses,
  styleHelper,
} from "../../helpers/commonFunctions";
import { logOrderProductsClickAddCart } from "../../membership/logging/helpers/commonLoggingFunctions";
import {ListingAddonCardDataType} from "../../interfaces/listingAddonCard/ListingAddonCard.type";
import styles from "./ListingAddonCard.module.css";

const ListingAddonCard = ({ item }: { item: ListingAddonCardDataType }) => {
  const icon = item?.icon;
  const title = item?.title;
  const description = item?.description;
  const priceLabel = item?.totalPriceLabel;
  const price = item?.totalPrice;
  const hint = description.hint;
  const action = item?.actionCheck;
  const duration = item?.duration;
  const durationLabel = item?.durationLabel;
  const isChecked = item?.isChecked;
  const { continueDraft,isCheckingAddon,setIsCheckingAddon } = useComponentsStore();
  const [isLoading, setIsLoading] = useState(false);
  const { setOpen } = useHintStore();

  const hintHandler = (e) => {
    e.stopPropagation();
    setOpen(true, hint?.link);
  };

  const onChangeHandler = async () => {
    if (isLoading || isCheckingAddon) return;
    try {
      logOrderProductsClickAddCart();
      setIsCheckingAddon(true);
      setIsLoading(true);
      await continueDraft(action.payload)
    } catch (err) {
      console.error(err);
    } finally {
      setIsCheckingAddon(false);
      setIsLoading(false);
    }
  }

  return (
    <div
      className={`vas-m-0 vas-p-3 vas-w-100 vas-card`}
      onClick={onChangeHandler}
      style={styleHelper({
        backgroundColor: item?.backgroundColor,
        border: `1px solid ${item?.borderColor}`,
      })}
    >
      <div className="pointerCursor vas-d-flex vas-gap-2 vas-align-item-start">
        {icon && (
            <img
                className="vas"
                src={getGeneralImage(icon)}
                alt="title_icon"
                height={40}
                width={40}
            />
        )}
        <div className="vas-d-flex vas-text-14 vas-ms-2 vas-flex-column">
          <div className="vas-d-flex">
            <div className={`vas-d-flex ${generateStyleClasses(priceLabel.style)}`} style={styleHelper({
              color: priceLabel.textColor
            })}>
              {priceLabel.text}
            </div>

          </div>
          {duration && <div className="vas-d-flex">
            <div className={`vas-d-flex ${generateStyleClasses(durationLabel.style)}`} style={styleHelper({
              color: durationLabel.textColor
            })}>
              {durationLabel.text}
            </div>
          </div>}
        </div>
        <div className={`vas-d-flex text-start vas-text-14 vas-ms-2 vas-flex-column vas-w-100`}>
          <div className={`vas-d-flex ${generateStyleClasses(price.style)}`} style={styleHelper({
            color: price.textColor
          })}>
            {price.text}
          </div>
          <div className={`vas-d-flex ${generateStyleClasses(duration.style)}`} style={styleHelper({
            color: duration.textColor
          })}>
            {duration.text}
          </div>
        </div>
        <div className={`vas-d-flex ${styles.auto_margin_dir}`}>
          <div
              className={`${styles.switch_container} ${isChecked ? styles.switch_container_on : styles.switch_container_off}`}>
            <div className={`${styles.switch_button} ${isChecked ? styles.switch_on : styles.switch_off}`}></div>
          </div>
        </div>
      </div>
      <div className="vas-d-flex vas-flex-column vas-mt-1 vas-gap-1 vas-justify-content-between vas-align-item-center">
        <div
            className={`vas-text-16 vas-pt-1 ${generateStyleClasses(title.style)}`}
            style={styleHelper({color: title?.textColor})}
        >
          {title?.text ?? ""}
        </div>
        <div
            className={`vas-text-14 ${generateStyleClasses(description.style)}`}
            style={styleHelper({color: description?.textColor})}
        >
          {description?.text ?? ""} <span onClick={hintHandler} className={`pointerCursor ${generateStyleClasses(hint.style)}`}>{hint.text}</span>
        </div>
      </div>
    </div>
  );
};

export default ListingAddonCard;
